import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styles/theme';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.1) 100%);
  backdrop-filter: blur(24px);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(99, 102, 241, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  margin: 20px 0;
`;

const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top: 4px solid rgba(99, 102, 241, 0.8);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 16px;
`;

const Message = styled.p`
  margin: 0;
  color: white;
  font-size: 16px;
  text-align: center;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;

const SubMessage = styled.p`
  margin: 8px 0 0 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
`;

interface Props {
  message?: string;
  subMessage?: string;
}

export const LoadingSpinner: React.FC<Props> = ({ 
  message = 'Loading...', 
  subMessage 
}) => {
  return (
    <Container>
      <Spinner />
      <Message>{message}</Message>
      {subMessage && <SubMessage>{subMessage}</SubMessage>}
    </Container>
  );
};